import { Grid } from "@mui/material";
import { Backfill } from "../../components";

import { DownloadsDataGridWithQuery } from "../../components/DownloadsDataGrid/DownloadsDataGridWithQuery";

const DownloadBrowser = () => {
  return (
    <>
      <Grid size={12} sx={{ mb: 2 }}>
        <Backfill />
      </Grid>
      <DownloadsDataGridWithQuery />
    </>
  );
};

export { DownloadBrowser };
